import {
	SET_LOGIN_ID,
	SET_INITIAL_LOGIN_STATE,
	CHANGE_LOGIN_ID,
	CHANGE_PIN,
	LOGIN_USER,
	SET_SOCIAL_LOGIN_USER_DETAIL,
	SOCIAL_LOGIN,
	FORGOT_PIN,
	UPDATE_ACTIVE_COURSE,
	SET_RESET_PATH,
	RESET_STATE,
	OTP_LOGIN,
	OTP_VERIFY,
	CHANGE_OTP,
	JUNIOR_LOGIN,
	SET_USER_TYPE,
	SET_ENABLE_PROCTOR,
} from './userAuth.actionTypes';

export const setLoginId = (text) => ({
	type: SET_LOGIN_ID,
	payload: text,
});

export const setResetPath = (text) => ({
	type: SET_RESET_PATH,
	payload: text,
});

export const resendState = () => ({
	type: RESET_STATE,
});

export const changeLoginId = (text) => ({
	type: CHANGE_LOGIN_ID,
	payload: text,
});

export const changePin = (text) => ({
	type: CHANGE_PIN,
	payload: text,
});

export const changeOtp = (text) => ({
	type: CHANGE_OTP,
	payload: text,
});

export const setInitialLoginState = (text) => ({
	type: SET_INITIAL_LOGIN_STATE,
	payload: text,
});

export const setSocialLoginUserDetails = (obj) => ({
	type: SET_SOCIAL_LOGIN_USER_DETAIL,
	payload: obj,
});

export const loginUser = () => ({
	type: LOGIN_USER.PENDING,
});

export const resendPin = () => ({
	type: FORGOT_PIN.PENDING,
});

export const onSocialLogin = () => ({
	type: SOCIAL_LOGIN.PENDING,
});

export const updateActiveCourse = (id) => ({
	type: UPDATE_ACTIVE_COURSE,
	payload: id,
});

export const otplogin = (val) => ({
	type: OTP_LOGIN.PENDING,
	payload: val,
});

export const juniorLogin = (val) => ({
	type: JUNIOR_LOGIN.PENDING,
	payload: val,
});

export const setUserType = (val) => ({
	type: SET_USER_TYPE,
	payload: val,
});

export const validateOtp = (obj) => ({
	type: OTP_VERIFY.PENDING,
	payload: obj,
});

export const setEnableProctor = (val) => ({
	type: SET_ENABLE_PROCTOR,
	payload: val,
});
